import { Navigate, Route, Routes } from "react-router-dom";
import { ShellLayout } from "./layouts/ShellLayout.js";
import { DashboardPage } from "./pages/dashboard/index.js";
import { GrammarPage } from "./pages/grammar/index.js";
import { LoginPage } from "./pages/login/index.js";
import { ReadingPracticePage } from "./pages/practice/reading.js";
import { WritingPracticePage } from "./pages/practice/writing.js";
import { ReviewPage } from "./pages/review/index.js";
import { SettingsPage } from "./pages/settings/index.js";
import { WordsPage } from "./pages/words/index.js";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ShellLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/words" element={<WordsPage />} />
        <Route path="/review" element={<ReviewPage />} />
        <Route path="/practice/reading" element={<ReadingPracticePage />} />
        <Route path="/practice/writing" element={<WritingPracticePage />} />
        <Route path="/grammar" element={<GrammarPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
